<template>
   <div class="questionnaire-manage">
      <div class="breadcrumb">
         问卷调查
         <span>
            <el-button class="right_f" type="primary" style="margin-left: 10px;" @click="loadModel">下载模版</el-button>
            <el-button class="right_f" type="primary" @click="addQuestionnaire">新增</el-button>
         </span>
      </div>

      <div class="search-bar">
         <div class="search-item">
            <span class="label">关键字：</span>
            <el-input 
               v-model="searchParams.keyword" 
               placeholder="请输入" 
               clearable
               style="width: 200px">
            </el-input>
         </div>

         <div class="search-item">
            <span class="label">状态：</span>
            <el-select v-model="searchParams.status" clearable placeholder="请选择" style="width: 200px">
               <el-option label="全部" :value="-1"></el-option>
               <el-option label="已发布" :value="0"></el-option>
               <el-option label="已撤销" :value="1"></el-option>
            </el-select>
         </div>

         <div class="search-item">
            <span class="label">日期选择：</span>
            <el-date-picker
               v-model="searchParams.dateRange"
               type="daterange"
               range-separator="—"
               start-placeholder="开始日期"
               end-placeholder="结束日期"
               style="width: 340px">
            </el-date-picker>
         </div>

         <div class="search-item">
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset">重置</el-button>
         </div>
      </div>

      <div class="com-list">
         <el-table :data="tableData" style="overflow-x: auto;" v-loading="loading">
            <el-table-column prop="index" label="序号" align="center" width="80">
            </el-table-column>

            <el-table-column prop="title" label="标题" align="center" width="150">
            </el-table-column>

            <el-table-column prop="rewardTypeName" label="奖励" align="center" width="150">
            </el-table-column>

            <el-table-column prop="dateRange" label="时间" align="center" width="250">
            </el-table-column>

            <el-table-column prop="scopeTypeName" label="涉及院系" align="center" width="120">
            </el-table-column>

            <el-table-column prop="statusName" label="状态" align="center" width="100">
            </el-table-column>

            <el-table-column label="中奖名单" align="center" width="120">
               <template slot-scope="scope">
                  <el-button 
                     class="option" 
                     type="text" 
                     @click="handleExportWinnerList(scope.row)">
                     查看名单
                  </el-button>
               </template>
            </el-table-column>

            <el-table-column label="操作" align="center" min-width="280">
               <template slot-scope="scope">
                  <div class="btn-box">
                     <!-- 编辑按钮：始终显示 -->
                     <el-button 
                        class="option" 
                        type="text" 
                        @click="handleEdit(scope.row)">
                        编辑
                     </el-button>
                     
                     <!-- 发布按钮：只在撤销发布状态显示 -->
                     <el-button 
                        v-if="scope.row.status === 2"
                        class="option" 
                        type="text" 
                        @click="handlePublish(scope.row)">
                        发布
                     </el-button>
                     
                     <!-- 撤销发布按钮：只在已发布状态显示 -->
                     <el-button 
                        v-if="scope.row.status === 1"
                        class="option" 
                        type="text" 
                        style="color: #E6A23C"
                        @click="handleRevoke(scope.row)">
                        撤销发布
                     </el-button>
                     
                     <!-- 删除按钮：只在撤销发布状态显示 -->
                     <el-button 
                        v-if="scope.row.status === 2"
                        class="option" 
                        type="text" 
                        style="color: #F56C6C"
                        @click="handleDelete(scope.row)">
                        删除
                     </el-button>
                     
                     <!-- 赠送按钮：始终显示 -->
                     <el-button 
                        class="option" 
                        type="text" 
                        @click="handleGift(scope.row)">
                        赠送
                     </el-button>
                  </div>
               </template>
            </el-table-column>
         </el-table>
      </div>

      <div class="pagination">
         <el-pagination
            v-show="totalCount > 0"
            layout="prev, pager, next, jumper"
            :page-size="pageSize"
            :current-page="currentPage"
            :total="totalCount"
            @current-change="handleCurrentChange">
         </el-pagination>
      </div>

      <!-- 赠送弹窗 -->
      <el-dialog 
         title="赠送" 
         :visible.sync="pushDialogVisible" 
         width="500px"
         :modal="false">
         <div class="push-dialog-content">
            <div class="dialog-tip">
               则弹出导入文件，可多次导入…
            </div>
            <div class="upload-area">
               <el-upload
                  class="upload-excel"
                  drag
                  action=""
                  :http-request="handleUploadExcel"
                  :before-upload="beforeUploadExcel"
                  :show-file-list="false"
                  accept=".xls,.xlsx">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                     <span style="color: #409EFF">点击上传</span> / 拖拽到此区域
                  </div>
               </el-upload>
               <div class="upload-tip">请上传Excel文件，大小不超过10MB内</div>
            </div>
            <div v-if="uploadedFileName" class="uploaded-file-name">
               已上传：{{ uploadedFileName }}
            </div>
         </div>
         <div slot="footer" class="dialog-footer">
            <el-button @click="pushDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="confirmPush">确定</el-button>
         </div>
      </el-dialog>
   </div>
</template>

<script>
export default {
   data() {
      return {
         loading: false,
         searchParams: {
            keyword: '',
            status: -1, // -1表示不筛选
            dateRange: []
         },
         tableData: [],
         currentPage: 1,
         pageSize: 20,
         totalCount: 0,
         pushDialogVisible: false,
         uploadedFileName: "",
         uploadedFile: null,
         currentPushRow: null, // 当前要赠送的行
      }
   },

   mounted() {
      this.getList();
   },

   activated() {
      // 当从其他页面返回时，刷新列表数据
      this.getList();
   },

   methods: {
      // 格式化时间戳为 yyyy-MM-dd 格式
      formatTimestamp(timestamp) {
         if (!timestamp) return '';
         // 如果是数字类型（时间戳）
         if (typeof timestamp === 'number') {
            const d = new Date(timestamp);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
         }
         // 如果是字符串，检查是否已经是正确格式
         if (typeof timestamp === 'string' && /^\d{4}-\d{2}-\d{2}/.test(timestamp)) {
            return timestamp.split(' ')[0]; // 去掉时间部分，只保留日期
         }
         return timestamp;
      },

      // 获取列表数据
      getList() {
         this.loading = true;
         
         const params = {
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            status: this.searchParams.status, // -1表示不筛选状态
            keyword: this.searchParams.keyword || ''
         };

         // 处理日期范围，转换为时间戳
         if (this.searchParams.dateRange && Array.isArray(this.searchParams.dateRange) && this.searchParams.dateRange.length === 2) {
            const startDate = this.searchParams.dateRange[0];
            const endDate = this.searchParams.dateRange[1];
            
            // 如果是 Date 对象，需要先格式化为字符串
            let startDateStr, endDateStr;
            if (startDate instanceof Date) {
               const year = startDate.getFullYear();
               const month = String(startDate.getMonth() + 1).padStart(2, '0');
               const day = String(startDate.getDate()).padStart(2, '0');
               startDateStr = `${year}-${month}-${day}`;
            } else {
               startDateStr = startDate;
            }
            
            if (endDate instanceof Date) {
               const year = endDate.getFullYear();
               const month = String(endDate.getMonth() + 1).padStart(2, '0');
               const day = String(endDate.getDate()).padStart(2, '0');
               endDateStr = `${year}-${month}-${day}`;
            } else {
               endDateStr = endDate;
            }
            
            // 转换为时间戳
            params.startTime = new Date(startDateStr + ' 00:00:00').getTime();
            params.endTime = new Date(endDateStr + ' 23:59:59').getTime();
         } else {
            params.startTime = null;
            params.endTime = null;
         }

         this.$http({
            method: 'POST',
            url: this.$util.domain + '/adminapi/user-research/list',
            body: JSON.stringify(params)
         }).then((response) => {
            if (response.data.error === 10000) {
               const dataList = response.data.data.models || [];
               this.totalCount = response.data.data.count || 0;
               
               // 处理列表数据
               this.tableData = dataList.map((item, index) => {
                  // 格式化时间戳为日期字符串
                  const startDate = item.startTime ? this.formatTimestamp(item.startTime) : '';
                  const endDate = item.endTime ? this.formatTimestamp(item.endTime) : '';
                  
                  return {
                     index: (this.currentPage - 1) * this.pageSize + index + 1,
                     id: item.id,
                     title: item.name,
                     rewardType: item.rewardName,
                     rewardTypeName: item.rewardName || '-',
                     dateRange: startDate && endDate ? `${startDate} — ${endDate}` : '-',
                     scopeType: item.scopeType,
                     scopeTypeName: item.scopeType === 1 ? '全部' : '部分',
                     status: item.status === 0 ? 1 : 2, // API: 0-已发布, 1-已撤销; 前端: 1-已发布，2-撤销发布
                     statusName: item.status === 0 ? '已发布' : '已撤销',
                     createTime: item.createTime,
                     updateTime: item.updateTime,
                  };
               });
            } else {
               this.$util.errorMsg(response.data.message || '获取列表失败');
            }
         }).catch((error) => {
            this.$util.errorMsg('获取列表失败');
         }).finally(() => {
            this.loading = false;
         });
      },

      // 搜索
      handleSearch() {
         this.currentPage = 1;
         this.getList();
      },

      // 重置
      handleReset() {
         this.searchParams = {
            keyword: '',
            status: -1,
            dateRange: []
         };
         this.currentPage = 1;
         this.getList();
      },

      // 下载模版
      loadModel() {
         location.href = "https://admin.gxapp.iydsj.com/template/userResearchRewardImport.xlsx";
      },

      // 新增
      addQuestionnaire() {
         this.$router.push({
            path: '/yunying/activity/questionnaireSurvey'
         });
      },

      // 编辑
      handleEdit(row) {
         this.$router.push({
            path: '/yunying/activity/questionnaireSurvey',
            query: { id: row.id }
         });
      },

      // 发布
      handlePublish(row) {
         this.$confirm(`确定要发布问卷"${row.title}"吗？`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(() => {
            this.loading = true;
            this.$http({
               method: 'POST',
               url: this.$util.domain + '/adminapi/user-research/publish',
               body: JSON.stringify({ id: row.id, status: 0 }) // API: 0-已发布
            }).then((response) => {
               if (response.data.error === 10000) {
                  this.$message.success('发布成功');
                  this.getList();
               } else {
                  this.$util.errorMsg(response.data.message || '发布失败');
               }
            }).catch((error) => {
               this.$util.errorMsg('发布失败');
            }).finally(() => {
               this.loading = false;
            });
         }).catch(() => {});
      },

      // 撤销发布
      handleRevoke(row) {
         this.$confirm(`确定要撤销发布问卷"${row.title}"吗？`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(() => {
            this.loading = true;
            this.$http({
               method: 'POST',
               url: this.$util.domain + '/adminapi/user-research/publish',
               body: JSON.stringify({ id: row.id, status: 1 }) // API: 1-已撤销
            }).then((response) => {
               if (response.data.error === 10000) {
                  this.$message.success('撤销发布成功');
                  this.getList();
               } else {
                  this.$util.errorMsg(response.data.message || '撤销发布失败');
               }
            }).catch((error) => {
               this.$util.errorMsg('撤销发布失败');
            }).finally(() => {
               this.loading = false;
            });
         }).catch(() => {});
      },

      // 删除
      handleDelete(row) {
         // 只有撤销发布状态才能删除
         if (row.status !== 2) {
            this.$util.errorMsg('只有撤销发布状态才能删除');
            return;
         }
         this.$confirm(`确定要删除问卷"${row.title}"吗？`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(() => {
            this.loading = true;
            this.$http({
               method: 'POST',
               url: this.$util.domain + '/adminapi/user-research/delete',
               body: JSON.stringify({ id: row.id })
            }).then((response) => {
               if (response.data.error === 10000) {
                  this.$message.success('删除成功');
                  this.getList();
               } else {
                  this.$util.errorMsg(response.data.message || '删除失败');
               }
            }).catch((error) => {
               this.$util.errorMsg('删除失败');
            }).finally(() => {
               this.loading = false;
            });
         }).catch(() => {});
      },

      // 赠送
      handleGift(row) {
         this.currentPushRow = row;
         this.pushDialogVisible = true;
         this.uploadedFileName = "";
         this.uploadedFile = null;
      },

      // 导出中奖名单
      handleExportWinnerList(row) {
         const url = this.$util.domain + `/adminapi/user-research/export?researchId=${row.id}`;
         window.open(url, '_blank');
      },

      // Excel上传前验证
      beforeUploadExcel(file) {
         const isExcel = file.type === 'application/vnd.ms-excel' || 
                        file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
         const isLt10M = file.size / 1024 / 1024 < 10;

         if (!isExcel) {
            this.$util.errorMsg('只能上传 Excel 文件');
            return false;
         }
         if (!isLt10M) {
            this.$util.errorMsg('文件大小不能超过 10MB');
            return false;
         }
         return true;
      },

      // 自定义上传Excel
      handleUploadExcel(options) {
         this.uploadedFile = options.file;
         this.uploadedFileName = options.file.name;
      },

      // 确认赠送
      confirmPush() {
         if (!this.uploadedFile) {
            this.$util.errorMsg('请上传Excel文件');
            return;
         }

         this.loading = true;
         
         // 构建FormData
         const formData = new FormData();
         formData.append('uploadFile', this.uploadedFile);

         this.$http({
            url: this.$util.domain + `/adminapi/user-research/import?researchId=${this.currentPushRow.id}`,
            method: "POST",
            body: formData
         }).then((res) => {
            if (res.body.error === 10000) {
               this.$message.success('赠送成功');
               this.pushDialogVisible = false;
               this.getList();
            } else {
               this.$util.errorMsg(res.body.message || '赠送失败');
            }
         }).catch((err) => {
            this.$util.errorMsg(err.message || '赠送失败');
         }).finally(() => {
            this.loading = false;
         });
      },

      // 分页切换
      handleCurrentChange(val) {
         this.currentPage = val;
         this.getList();
      },
   }
}
</script>

<style scoped>
.questionnaire-manage {
   padding: 20px;
}

.breadcrumb {
   display: flex;
   justify-content: space-between;
   align-items: center;
   margin-bottom: 20px;
   font-size: 16px;
   font-weight: bold;
}

.right_f {
   float: right;
}

.search-bar {
   background: #fff;
   padding: 20px;
   margin-bottom: 20px;
   border-radius: 4px;
   display: flex;
   flex-wrap: wrap;
   align-items: center;
   gap: 15px;
}

.search-item {
   display: flex;
   align-items: center;
}

.search-item .label {
   font-size: 14px;
   color: #606266;
   white-space: nowrap;
   margin-right: 8px;
}

.com-list {
   background: #fff;
   padding: 20px;
   border-radius: 4px;
}

.btn-box {
   display: flex;
   flex-wrap: wrap;
   justify-content: center;
   gap: 5px;
}

.btn-box .el-button {
   padding: 5px 10px;
   margin: 0;
}

.pagination {
   margin-top: 20px;
   text-align: center;
}

.push-dialog-content {
   padding: 20px 0;
}

.dialog-tip {
   margin-bottom: 15px;
   font-size: 14px;
   color: #606266;
   text-align: center;
}

.upload-area {
   text-align: center;
}

.upload-excel {
   width: 100%;
}

.upload-tip {
   margin-top: 10px;
   font-size: 12px;
   color: #999;
   text-align: center;
}

.uploaded-file-name {
   margin-top: 15px;
   padding: 10px;
   background-color: #f5f7fa;
   border-radius: 4px;
   font-size: 14px;
   color: #606266;
}

.dialog-footer {
   text-align: right;
}
</style>

<style>
.questionnaire-manage .el-upload-dragger {
   width: 100%;
   height: 150px;
}
</style>




// WEBPACK FOOTER //
// questionnaireManage.vue?1c794d13